import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getDefaultRoute } from '../utils/getDefaultRoute';
import { isAssessmentOrchestrationUiEnabled } from '../config/assessmentFlags';

/**
 * Blocks assessment route shell when the UI flag is OFF (AO-1.15 / AD-20).
 * Matches nav visibility — no URL bypass. Authorization remains on the server.
 */
export function RequireAssessmentOrchestration({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!isAssessmentOrchestrationUiEnabled()) {
    return <Navigate to={getDefaultRoute(user.role, user)} replace />;
  }
  return children;
}
